import $ from 'jquery';

class FacebookComponent {
    bind() {
        if ($('[data-event="login-facebook"]').length > 0) {
           facebookComponent.saveRedirect();
        }
        $(document).on('click', '[data-event="login-facebook"]', function (e) {
            e.preventDefault();

            const facebookRedirect = this.getAttribute('href');
            FB.login(function (response) {
                if (response.status === 'connected') {
                    window.location.href = facebookRedirect
                }
            });
        })
    }

    saveRedirect(){
        fetch('/redirect', {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content'),
            },
            body: JSON.stringify({
                redirect: window.location.href
            })
        })
    }
}

export const facebookComponent = new FacebookComponent();


$(function () {
    facebookComponent.bind();
})
